import React, { Component } from 'react';
import { Dropdown, Menu, Sidebar, Icon, Segment, Label, Image } from 'semantic-ui-react';
import './style/App.css';
import config from './config';
import {isMobile} from './utils';

const { humburger} = config.website.header.menu;

const renderMenuItems = (items) => {
  return items.map(item => 
   {return(<Dropdown.Item onClick = {item.onClick}>{item.text}</Dropdown.Item>);});
}

class HeaderMenu extends Component {
  state = { visible: humburger.stuck || false }
  toggleVisibility = () => this.setState({ visible: !this.state.visible })

  onItemClick = (item)=>{ 
    item.onClick(); 
    if(!humburger.stuck && humburger.autohide){
      this.toggleVisibility();
    }
  }

  renderMenuItems = (items) => {
    return items.map(item => {
      return(
      <Dropdown.Item onClick = {(e)=>this.onItemClick(item)}>
        {item.text}
        <Icon name={item.icon}/>
      </Dropdown.Item>);});
  }
  
  render() {
    const {header} = config.website; 
    return (                          
            <Segment.Group horizontal style={Style.headerWrap}>
              <Menu className="header" style={Style.header} fixed = 'top'>
              
              {header.menu.logo.show ?
                <Dropdown trigger={<Image size='tiny' src={header.icon}/>} item simple>
                  <Dropdown.Menu  style={{...header.menu.logo.style }}>
                     {renderMenuItems(this.props.menuItems)}
                  </Dropdown.Menu>
                </Dropdown> : 
                <Image style={Style.logoMenu} size='tiny' src={header.icon}/>}

                <p style={{...Style.title, ...header.style }}>{this.props.title}</p>

                {header.menu.humburger.show && 
                <Label style={{...Style.btnMenu, ...header.menu.humburger.style }} 
                  compact icon='sidebar' size='big' onClick={this.toggleVisibility}>
                </Label>}
                <Sidebar as={Menu} style={{...header.menu.humburger.style }}
                animation='scale down' 
                direction={isMobile() ? 'top' : 'right'} 
                //width='thin' 
                vertical 
                visible={this.state.visible}>
                  {!humburger.stuck && 
                  <Menu.Item name='close' onClick={this.toggleVisibility}>
                  <Icon name='close' />
                  </Menu.Item>}
                  {this.renderMenuItems(this.props.menuItems)}
                </Sidebar>
              </Menu>
            </Segment.Group>
            
          );
  }
}
const mobile = isMobile();
const Style = {
  logoMenu: {
    height: mobile ? '3em' : '5em',
    width: mobile ? '3em' : '5em',
    margin: mobile ? '0.5em' : '2em',
  },
  btnMenu: {
    position: 'fixed',
    right: '0px',
    width: '45px',
    margin: '3% 10px',
    background: 'white'
  },
  header: {
//    background: "linear-gradient( yellow 20%, #40bf40, #993300)"
      background: config.website.header.style.background,
      height: mobile ? '50px' : '90px',
  },
  headerWrap: {
    top:'-15px',
    width: '1000px',
    height:'auto',
  },
  title: {
    width: '1000px',
    opacity: mobile ? '0':'1',
  },
}
export default HeaderMenu


// WEBPACK FOOTER //
// ./src/HeaderMenu.js